export default __webpack_public_path__ + "static/media/Udemy-C++.e978f710.png";